import MenuMinimize from '../../../components/1elements/Icons/svg/adminLeftMenu/menuMinimize.svg'
import MenuClose from '../../../components/1elements/Icons/svg/adminLeftMenu/menuClose.svg'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { useNavigate } from 'react-router-dom'

const MenuTopButtons = ({ minimizeMenu, setMinimizeMenu }) => {
  const classes = useStyles({ minimizeMenu })
  const navigate = useNavigate()

  const handleMenuClose = () => navigate('/home')

  return (
    <div className={classes.root}>
      <img
        src={MenuMinimize}
        alt="miniize"
        className={classes.topMenuButton}
        onClick={() => setMinimizeMenu((prev) => !prev)}
      />
      <img
        src={MenuClose}
        alt="close"
        className={`${classes.topMenuButton} ${classes.closeButton}`}
        onClick={handleMenuClose}
      />
    </div>
  )
}

export default MenuTopButtons

const useStyles = makeStyles((theme, props) => ({
  root: {
    position: 'fixed',
    zIndex: 10,
    backgroundColor: theme.palette.quaternary.accent,
    width: (props) => (props.minimizeMenu ? 'auto' : '235px'),
    maxWidth: (props) => (props.minimizeMenu ? '100px' : '400px'),
    padding: (props) =>
      props.minimizeMenu ? '13px 20px' : '13px 20px 13px 25px',
    borderBottom: `1px solid ${theme.palette.secondary.main}`,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    transition: 'all 0.2s ease'
  },
  topMenuButton: {
    '&:hover': {
      cursor: 'pointer'
    }
  },
  closeButton: {
    marginLeft: '12px'
  }
}))
